import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import {
  generateAction,
  generateSchemaAssetType,
  mergeActions,
  saveConfig
} from './utils';
import { editActionsWithNewData } from '../OnEdit/onEdit';

export const onEdit = async (
  formData,
  actionToEdit,
  currentStep,
  setActionToEdit,
  assetTypes,
  config,
  data,
  setData,
  tempConfigFile,
  setNewTempConfigFile,
  _next,
  newTempConfigFile,
  saveTempConfigFile,
  setNotification,
  open,
  toggleForm,
  setCurrenStep
) => {
  let newAction = actionToEdit;
  try {
    switch (currentStep) {
      default: { // case 0
        newAction = generateAction(formData, assetTypes, config, actionToEdit);
        setActionToEdit(newAction);
        const assetType = assetTypes.find(assetType => assetType.id === formData.asset);
        const [schemaAssetType, uiSchemaAssetType] = generateSchemaAssetType(assetType, actionToEdit);
        const newData = [
          { ...data[0], formData },
          { ...data[1], schema: schemaAssetType, uiSchema: uiSchemaAssetType }];
        setData(newData);
        let auxNewTempConfigFile = Object.assign(config);
        const actionIndex = auxNewTempConfigFile.actions.findIndex(action => action.id === formData.id);
        auxNewTempConfigFile.actions[actionIndex] = newAction;
        auxNewTempConfigFile = await editActionsWithNewData(
          tempConfigFile,
          formData
        );
        setNewTempConfigFile(auxNewTempConfigFile);
        _next();
        break;
      }
      case 1: {
        const finalAction = mergeActions(actionToEdit, formData);
        newTempConfigFile.actions.forEach((action, i) => {
          if (action.id === finalAction.id) {
            newTempConfigFile.actions[i] = finalAction;
          }
        });
        newTempConfigFile.transitions.forEach((transition, i) => {
          transition.actions.forEach((action, index) => {
            if (action.id === finalAction.id) {
              newTempConfigFile.transitions[i].actions[index] = finalAction;
            }
          });
        });
        saveConfig(newTempConfigFile, saveTempConfigFile, setNotification, open, toggleForm);
        break;
      }
    }
  } catch (err) {
    console.error(err);
    setNotification({
      type: 'error',
      message: funcTranslateHelper('Builder.Message.error')
    });
    setTimeout(() => setNotification(null), 2000);
    if (open) toggleForm();
  }
};
